import React, {Component} from "react";
import {ServerSidePaginationTable, TableButtonsBuilder} from "../../../components/Letflow/Table";
import {request} from '../../../api-client'
import localization from '../../../config/localization'
import {makeUrlWithTableParams} from "../../../utils";
import {FormControl, FormControlLabel, RadioGroup} from "@material-ui/core/index";
import Radio from "@material-ui/core/Radio";

let table

class Table extends Component {
  state = {
    containerType: 'all',
    copied: localization.get('copy_link'),
    loaded: true
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      table.forceUpdate()
    }
  }


  render = () => {
    const { loaded } = this.state;
    const {isTalent} = this.props;

    return !loaded ? <div></div> :
      (
      <>
        <div style={{ width: "100%", float: "left", position: "relative" }}>
          {isTalent &&
            <FormControl style={{width: "100%", float: "left", position: "relative"}}>
              <RadioGroup
                name="type"
                value={this.state.containerType}
                onChange={event => {
                  this.setState({containerType: event.target.value})
                  table.forceUpdate();
                }}
                style={{width: "100%", float: "left", position: "relative", flexDirection: "row"}}
              >
                <FormControlLabel style={{width: "fit-content", float: "left", position: "relative"}} value="all"
                                  control={<Radio color="default"/>} label={localization.get('clients.all')}/>
                <FormControlLabel style={{width: "fit-content", float: "left", position: "relative"}} value="bloomclouds"
                                  control={<Radio color="default"/>} label={"Creators"}/>
                <FormControlLabel style={{width: "fit-content", float: "left", position: "relative"}} value="bigCreator"
                                  control={<Radio color="default"/>} label={"Big Creators"}/>
              </RadioGroup>
            </FormControl>
          }
          <ServerSidePaginationTable
            ref={r => table = r}
            style={{width: "100%", float: "left", position: "relative"}}
            columns={[
              {
                Header: localization.get('table.name'),
                accessor: "name",
                Filter: ({filter, onChange}) => (
                  <input
                    onChange={event => onChange(event.target.value)}
                    value={filter ? filter.value : ''}
                    placeholder={localization.get('table.search')}
                  />
                ),
              },
              {
                Header: localization.get('table.actions'),
                id: 'actions',
                sortable: false,
                filterable: false,
                accessor: contentCreatorType => {
                  const builder = new TableButtonsBuilder()

                  builder.withEdit(makeUrlWithTableParams(isTalent ? `/panel/talents/content_creator_types/${contentCreatorType.id}/edit` : this.props.isAudiovisual ? `/panel/audiovisual/content_creator_types/${contentCreatorType.id}/edit` : `/panel/editorial/content_creator_types/${contentCreatorType.id}/edit`))
                  builder.withDelete(contentCreatorType.name, () => request.contentCreatorType.delete(contentCreatorType.id), status => {
                      if (status === 'passed') {
                        table.removeById(contentCreatorType.id)
                      }
                    }, true, localization.get("table.delete.content_creator_type"))
                  return builder.build();
                }
              }
            ]}
            requestTableData={paginationConfig => {
              paginationConfig = { ...paginationConfig, filterBy: paginationConfig.filterBy.concat([{ column: 'type', filter: isTalent ? "talent" : this.props.isAudiovisual ? "audiovisual" : "editorial" }])}
              if (this.state.containerType !== "all") {
                paginationConfig = { ...paginationConfig, filterBy: paginationConfig.filterBy.concat([{ column: 'brand', filter: this.state.containerType }])}
              }

              return request.contentCreatorType.getAll(paginationConfig)
            }}
          />
        </div>
      </>
    )
  }
}


export default Table
